(() => {
  const root = document.documentElement;
  const canHover = window.matchMedia('(hover: hover)').matches;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (canHover && !reducedMotion) {
    window.addEventListener('pointermove', (event) => {
      root.style.setProperty('--zen-pointer-x', `${(event.clientX / window.innerWidth - 0.5) * 2}`);
      root.style.setProperty('--zen-pointer-y', `${(event.clientY / window.innerHeight - 0.5) * 2}`);
    }, { passive: true });
  }

  if (!reducedMotion && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('zen-is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    document.querySelectorAll('[data-zen-reveal]').forEach((element) => observer.observe(element));
  } else {
    document.querySelectorAll('[data-zen-reveal]').forEach((element) => element.classList.add('zen-is-visible'));
  }
})();
